import photo_1 from "./DublinPictures/Photo-01.webp";
import photo_2 from "./DublinPictures/Photo-02.webp";
import photo_3 from "./DublinPictures/Photo-03.webp";
import photo_4 from "./DublinPictures/Photo-04.webp";
import photo_5 from "./DublinPictures/Photo-05.webp";

export const DublinPhotoContent = [
  {
    id: 1,
    title: "Photos",
    // Following the template, 'latestPicture' is the first item in the list
    latestPicture: {
      image: photo_1,
      date: "5 February 2025",
      time: "11:49am",
      location: "Dublin, Ireland",
    },
    pictures: [
      {
        image: photo_1,
        date: "5 February 2025",
        time: "11:49am",
        location: "Dublin, Ireland",
      },
      {
        image: photo_2,
        date: "17 Feb 2025",
        time: "8:27am",
        location: "Dublin Castle",
      },
      {
        image: photo_3,
        date: "27 February 2025",
        time: "6:12pm",
        location: "Dublin, Ireland",
      },
      {
        image: photo_4,
        date: "2 March 2025",
        time: "7:19pm",
        location: "Dublin, Ireland",
      },
      {
        image: photo_5,
        date: "7 April 2025",
        time: "1:13pm",
        location: "Dublin Castle",
      },
    ],
  },
];
